<template>
  <v-container fill-height fluid>
    <v-layout align-center justify-center>
      <v-flex md4 sm8 xs12>
        <v-card class="elevation-12">
          <v-card-text>
            <v-text-field
              outline
              :label="$t('fields.old_password')"
              :type="'password'"
              v-model="changeData.old_password"
            ></v-text-field>
            <v-text-field
              outline
              :label="$t('fields.new_password_1')"
              :type="'password'"
              v-model="changeData.new_password_1"
            ></v-text-field>
            <v-text-field
              outline
              :label="$t('fields.new_password_2')"
              :type="'password'"
              v-model="changeData.new_password_2"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="setClick" color="primary">{{
              $t('buttons.passwordSet')
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Password',
  data() {
    return {
      changeData: {
        old_password: '',
        new_password_1: '',
        new_password_2: '',
      },
    }
  },
  methods: {
    setClick() {
      //var vm = this;
      //this.$APICall('post', "USERS", "/set-password", this.event, function (data) {
      // console.log(JSON.stringify(data));
      // }, false);
    },
  },
}
</script>
